import React from 'react';
import { cn } from '../lib/utils';

const SortableTableHeader = ({
  children,
  sortKey,
  currentSort,
  onSort,
  className = '',
  sortable = true,
}) => {
  const handleClick = () => {
    if (sortable && onSort && sortKey) onSort(sortKey);
  };

  const isActive = currentSort?.key === sortKey;

  const SortIcon = () => {
    if (!sortable || !sortKey) return null;
    if (isActive) {
      return currentSort.direction === 'asc' ? (
        <svg className="w-2.5 h-2.5 ml-1 text-ginox-green shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
        </svg>
      ) : (
        <svg className="w-2.5 h-2.5 ml-1 text-ginox-green shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      );
    }
    return (
      <span className="ml-1 text-muted-foreground/30 text-[10px] leading-none">:</span>
    );
  };

  return (
    <th
      className={cn(
        'border-b border-border/70 px-5 py-3 text-[10px] font-medium uppercase tracking-[1.5px] text-[#9aa1ac] select-none text-left',
        sortable && sortKey ? 'cursor-pointer' : '',
        className,
      )}
      onClick={handleClick}
    >
      <div className="flex items-center">
        {children}
        <SortIcon />
      </div>
    </th>
  );
};

export default SortableTableHeader;
